import itemQuickform  from "./item-quickform.html";

const dialog               = require ('../../../../../components/dialog/dialog')
const quickformEntity      = require ('../../../../../components/quickform/quickform-entity')
const quickformHandler     = require ('../../../../../components/quickform/quickform-handler')
const {formCopy}           = require('./item-quickform-form') 
const {form}               = require('./item-quickform-form')

/****************ELEMENTS*****************/
var htmlQf   = {}         
var HTMLwasSelected = false

function HTMLselect(detail){ 

      
	quickformHandler.HTMLselect(

            'item', //database table name****
            'item-quickform', 
            detail.ev.target, //source, for example AC
             itemQuickform, 
             form, 
             formCopy, 
             htmlQf)

	HTMLwasSelected   = true  


}/**/

export function start(detail){ 
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
       
      obj[detail.act].start(detail)
}/**/

const obj = {

      addOne:           { start: (detail)=>{  addOne(detail,htmlQf)                          }},
      hide:             { start: (detail)=>{  quickformEntity.hide(detail, htmlQf)           }},
      prepareAdd:       { start: (detail)=>{  quickformEntity.prepareAdd(detail, htmlQf)     }},
}/**/

function addOne(detail, htmlQf){

      quickformEntity.addOne(detail, htmlQf);
}